import { Modal, Button, Form, Input, message, Divider } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import axios from "./../../../services/http";

const ModalAddBuilderComponent = ({ obra, openDialogContratista, cancelBuilderDialog, savedBuilder }) => {

    const [contratistaForm] = Form.useForm();

    const handleAddContratista = async (values) => {
        try {
            const { nuevoContratista } = values;
            const response = await axios.HTTP_POST('/api/contratistas', {
                nombre_contratista: nuevoContratista,
                obra_id: obra.id,
            });
            if (response) {
                savedBuilder(response);
                contratistaForm.resetFields();
                cancelBuilderDialog(false);
                message.success('¡Guardado con éxito!');
            }

        } catch (error) {
            console.error('Error al añadir el contratista:', error);
            message.error('Hubo un error al añadir el contratista');
        }
    };

    return (
        <>
            <Modal
                title={`Nuevo contratista - (${obra.nombre_obra})`}
                open={openDialogContratista}
                onCancel={() => cancelBuilderDialog(false)}
                footer={null}
                >
                <Form
                    form={contratistaForm}
                    layout="vertical"
                    onFinish={handleAddContratista}
                >
                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item
                        label="Nombre"
                        name="nuevoContratista"
                        rules={[{ required: true, message: 'Favor de ingresar el nombre del contratista' }]}
                     >
                        <Input />
                    </Form.Item>

                    <Divider style={{ margin: '24px 0' }} />

                    <Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            <Button onClick={() => cancelBuilderDialog(false)} style={{ marginRight: 8 }}>
                                Cancelar
                            </Button>
                            <Button type="primary" htmlType="submit">
                                <SaveOutlined /> Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModalAddBuilderComponent;